import { render, staticRenderFns } from "./nxMobileDatalist.vue?vue&type=template&id=09207d69&scoped=true&"
import script from "./nxMobileDatalist.vue?vue&type=script&lang=js&"
export * from "./nxMobileDatalist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09207d69",
  null
  
)

export default component.exports